// Styles
import styles from "./index.module.css";

// Components
import { Grid, Popover, Typography } from "@mui/material";

const ExamMenu = ({ examMenu, examMenuClose, examMenuButtons }) => {
  return (
    <Popover
      sx={{ mt: 0 }}
      open={Boolean(examMenu)}
      anchorEl={examMenu}
      onClose={examMenuClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      PaperProps={{
        style: {
          width: "200px",
        },
      }}
      classes={{
        paper: "py-4 px-2",
      }}
    >
      {examMenuButtons.map((examMenuButton) => (
        <button
          key={examMenuButton.text}
          className={styles.menu_item}
          style={{ display: examMenuButton.display ? "flex" : "none" }}
          onClick={examMenuButton.onClick}
        >
          <Grid container display="flex" alignItems="center" gap="8px">
            {examMenuButton.icon}
            <Typography>{examMenuButton.text}</Typography>
          </Grid>
        </button>
      ))}
    </Popover>
  );
};

export default ExamMenu;
